import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import NhanVayApi from "../../../service/nhanVayApi";
import { formatDayMonth } from "utils/formatDate";
import { getListNhanVay, updateDataSearch } from "../../../actions/NhanVay/";
import UploadMultiFile from "components/GenericComponent/UploadMultiFile";
import UploadMultiFile1 from "components/GenericComponent/UploadMultiFile1";
import { ChuNo } from "./ChuNo";
import { ThongTinNhanVay } from "./ThongTinNhanVay";
import { currentDate } from "utils/formatDate";
import { getDate } from "utils/formatDate";
import { convertToNumber } from "utils/numberExtension";
import CauHinhApi from "../../../service/cauHinhApi";
import ConfigSystemApi from "service/QuanTriHeThong/CauHinhTinhLaiVaHeThong/ConfigSystemApi";
import { tinhNgayTraGocv3 } from "utils/choVayUtils";
import { pushNotification } from "utils/notifications";
import TaiSanApi from "../../../service/taiSanApi";
import CustomerForm from "../CustomerForm";
import useHinhThucThanhToan from "utils/useHinhThucThanhToan";

export const ModalThemMoiNhanVay = (props) => {
  const dispatch = useDispatch();

  const thongbaoerror = {
    Message: "",
    Error: 0,
  };
  const [isAllowDelete, setIsAllowDelete] = useState(thongbaoerror);
  const CheckSuaNhanVay = () => {
    NhanVayApi.kiemtraSuaNhanVay(props.NhanVayID).then((response) => {
      setIsAllowDelete({
        ...isAllowDelete,
        Message: response.data.Message,
        Error: response.data.Error,
      });
    });
  };

  useEffect(() => {
    CheckSuaNhanVay();
  }, []);

  const dataSearch = useSelector((state) => state.dataSearchNhanVay);
  const quanlycuahang = useSelector((state) => state.quanlycuahang);
  let { thongTinCuaHang } = quanlycuahang ? quanlycuahang : {};
  const currentForm = useForm();
  const { register, handleSubmit, errors, control, setValue } = currentForm;
  const initChuno = {
    CustomerId: 0,
    Address: "",
    Phone: "",
    CustomerName: "",
    IsEditCustomer: true,
  };
  const initTTNhanVay = {
    Note: "",
    NgayVay: currentDate(),
    Sotienvay: 0,
    CountTypePaid: 0,
    KieuLaiSuat: 1,
    TaiSanTheChap: "", //
    TypePaid: 1,
    NgayTra: currentDate(),
    BeforeAfter: 1,
    SoLanTra: 0,
    Code: "",
    NhanVayId: 0,
    LaiSuat: "",
    AnhTaiSan: "", //
    FileDinhKems: "",
    // NoteTaiSan: "", //
    GiayToTheChap: "",
    ImageList: [],
    IsNgayTraGoc: true,
    PhanTram: 0,
    MaNhanVay: "",
    LaiNgayTong: 0,
  };
  const [ChuNoValue, setChuNo] = useState(initChuno);
  const [TTNhanVayValue, setTTNhanVay] = useState(initTTNhanVay);
  const batHinhThucThanhToan = useHinhThucThanhToan();
  const [hinhThucThanhToan, setHinhThucThanhToan] = useState("0");
  const [fileDinhKems, setFileDinhKems] = useState([]);
  const [linkDinhKem, setLinkDinhKem] = useState("");
  const [imageTaiSans, setImageTaiSans] = useState([]);
  const [NoteTaiSan, setNoteTaiSan] = useState([""]);
  //Cấu hình huy động vốn
  const initCauHinhNhanVay = {
    KyDongLai: "0",
    KyDongLaiNgayEnabled: true,
    KyDongLaiThangEnabled: true,
    KyDongLaiThangDinhKyEnabled: true,
    KyDongLaiMacDinh: 1,
    LaiTrieuNgay_NgayEnabled: true,
    LaiNgay_NgayEnabled: true,
    LaiThang_NgayEnabled: true,
    LaiSuatNgayMacDinh: 1,
    LaiSuatNgay: "0",
    LaiTrieuNgay_ThangEnabled: true,
    LaiNgay_ThangEnabled: true,
    LaiThang_ThangEnabled: true,
    LaiSuatThangMacDinh: 1,
    LaiSuatThang: "0",
    AllBeforeAfter: true,
    BeforeAfter: 1,
  };
  const [cauHinhNhanVay, setCauHinhNhanVay] = useState(initCauHinhNhanVay);

  //Mặc định bị tắt trong cấu hình thì lấy lựa chọn đầu tiên đang bật (đúng thứ tự dropdown)
  const chonKyMacDinh = (cauHinh) => {
    const kyBat = [
      cauHinh.KyDongLaiNgayEnabled && 1,
      cauHinh.KyDongLaiThangDinhKyEnabled && 3,
      cauHinh.KyDongLaiThangEnabled && 2,
    ].filter(Boolean);
    return kyBat.includes(cauHinh.KyDongLaiMacDinh)
      ? cauHinh.KyDongLaiMacDinh
      : kyBat[0] || 1;
  };

  const chonKieuLaiSuatMacDinh = (cauHinh, typePaid) => {
    const ky = typePaid === 2 ? "Thang" : "Ngay";
    const kieuBat = [
      cauHinh[`LaiTrieuNgay_${ky}Enabled`] && 1,
      cauHinh[`LaiNgay_${ky}Enabled`] && 2,
      cauHinh[`LaiThang_${ky}Enabled`] && 3,
    ].filter(Boolean);
    const macDinh =
      typePaid === 2 ? cauHinh.LaiSuatThangMacDinh : cauHinh.LaiSuatNgayMacDinh;
    return kieuBat.includes(macDinh) ? macDinh : kieuBat[0] || 1;
  };

  //LaiSuat/PhanTram/LaiNgayTong gán cùng giá trị vì ô lãi suất hiển thị theo KieuLaiSuat; chưa cấu hình thì để trống bắt nhập.
  //Tháng định kỳ backend luôn tính Lãi%/tháng nên chỉ lấy lãi suất Tháng khi mặc định của Tháng là Lãi%/tháng
  const layMacDinhTheoKy = (cauHinh, typePaid) => {
    let laiSuat = 0;
    if (typePaid !== 3)
      laiSuat = convertToNumber(
        typePaid === 2 ? cauHinh.LaiSuatThang : cauHinh.LaiSuatNgay,
      );
    else if (chonKieuLaiSuatMacDinh(cauHinh, 2) === 3)
      laiSuat = convertToNumber(cauHinh.LaiSuatThang);
    const giaTri = laiSuat > 0 ? laiSuat : "";
    const macDinh = {
      TypePaid: typePaid,
      CountTypePaid: convertToNumber(cauHinh.KyDongLai) || 0,
      LaiSuat: giaTri,
      PhanTram: giaTri,
      LaiNgayTong: giaTri,
    };
    if (typePaid !== 3)
      macDinh.KieuLaiSuat = chonKieuLaiSuatMacDinh(cauHinh, typePaid);
    return macDinh;
  };

  //Cấu hình tính lãi
  const initCauHinhTinhLai = {
    OptionTinhLai: 3,
    IsTongSoNgay: false,
  };
  const [cauHinhTinhLai, setCauHinhTinhLai] = useState(initCauHinhTinhLai);
  //check edit
  const initEdit = {
    IsAllow: true,
    Message: "",
  };
  const [IsEdit, setEdit] = useState(initEdit);

  const initListHangTheChap = {
    AnhTaiSan: "",
    TaiSanId: "",
    TaiSanCode: "",
    LoaiTaiSan: 0,
    TaiSanNote: "",
    PhiKho: 0,
    TaiSanStore: 1,
    TenTaiSan: "",
    ThuocTinhTaiSan: [],
  };
  const [dataListHangTheChap, setListHangTheChap] =
    useState(initListHangTheChap);

  useEffect(() => {
    ConfigSystemApi.getCauHinhNhanVay().then((response) => {
      if (response.status !== 200 || !response.data) return;
      const cauHinh = response.data;
      setCauHinhNhanVay(cauHinh);
      if (!(props.NhanVayID > 0)) {
        setTTNhanVay((prev) => ({
          ...prev,
          ...layMacDinhTheoKy(cauHinh, chonKyMacDinh(cauHinh)),
          BeforeAfter: cauHinh.BeforeAfter,
        }));
      }
    });
    if (props.NhanVayID > 0) {
      NhanVayApi.checkEditNhanVay(props.NhanVayID).then((response) => {
        setEdit({
          ...IsEdit,
          IsAllow: response.data.IsAllow,
          Message: response.data.Message,
          CoThayDoiGoc: response.data.CoThayDoiGoc === true,
        });
      });

      TaiSanApi.taiSanTheoNhanVay1(props.NhanVayID).then((response) => {
        console.log("response.data", response.data);
        if (response.data.length > 0) {
          console.log("response.data[0]", response.data[0]);
          setListHangTheChap({
            ...dataListHangTheChap,
            AnhTaiSan: response.data[0].AnhTaiSan,
            TaiSanId: response.data[0].TaiSanId,
            TaiSanCode: response.data[0].TaiSanCode,
            LoaiTaiSan: response.data[0].LoaiTaiSan,
            TaiSanNote: response.data[0].TaiSanNote,
            PhiKho: response.data[0].PhiKho,
            TaiSanStore: response.data[0].TaiSanStore,
            TenTaiSan: response.data[0].TenTaiSan,
            ThuocTinhTaiSan: response.data[0].ThuocTinhTaiSan,
          });
        }
      });

      NhanVayApi.getOneDetail(props.NhanVayID).then((response) => {
        setChuNo({
          ...ChuNoValue,
          CustomerId: response.data.CustomerId,
          Address: response.data.Address,
          Phone: response.data.Phone,
          CustomerName: response.data.TenKhachHang,
          Img: response.data.AnhKhachHang,
          CMT: response.data.Cmt,
          DateCMT: response.data.DateCmt,
          AddressCMT: response.data.AddressCmt,
        });
        setTTNhanVay({
          ...TTNhanVayValue,
          Note: response.data.GhiChu,
          Sotienvay: response.data.Sotienvay,
          CountTypePaid: response.data.CountTypePaid,
          KieuLaiSuat: response.data.KieuLaiSuat,
          TypePaid: response.data.TypePaid,
          NgayVay: getDate(response.data.NgayVay),
          NgayTra: getDate(response.data.NgayTra),
          BeforeAfter: response.data.BeforeAfter,
          SoLanTra: response.data.SoLanTra,
          NhanVayId: props.NhanVayID,
          LaiSuat: response.data.LaiNgay,
          PhanTram: response.data.PhanTram,
          GiayToTheChap: response.data.GiayToTheChap,
          IsNgayTraGoc: response.data.IsNgayTraGoc,
          MaNhanVay: response.data.MaNhanVay,
          LaiNgayTong: response.data.LaiNgayTong,
        });
        setHinhThucThanhToan(String(response.data.HinhThucThanhToan || 0));

        if (response.data.DsTaiSanNhanVay.length > 0) {
          setNoteTaiSan(response.data.DsTaiSanNhanVay[0].TaiSanNote);
          setImageTaiSans(
            response.data.DsTaiSanNhanVay[0].AnhTaiSan
              ? response.data.DsTaiSanNhanVay[0].AnhTaiSan.split(";")
              : [],
          );
        }
        setFileDinhKems(
          response.data.FileDinhKems
            ? response.data.FileDinhKems.split(";")
            : [],
        );
      });
      //.then(response =>  props.onHide());
      //cấu hình tính lãi
      CauHinhApi.getConfig().then((response) => {
        setCauHinhTinhLai({
          ...cauHinhTinhLai,
          OptionTinhLai: response.data[0].OptionTinhLai,
          IsTongSoNgay: response.data[0].IsTongSoNgay,
        });
      });
    } else {
      //cấu hình tính lãi
      CauHinhApi.getConfig().then((response) => {
        setCauHinhTinhLai({
          ...cauHinhTinhLai,
          OptionTinhLai: response.data[0].OptionTinhLai,
          IsTongSoNgay: response.data[0].IsTongSoNgay,
        });
      });
    }
  }, [props.NhanVayID]);

  const updateChuNo = (chuno) => {
    setChuNo(chuno);
    //alert(chuno.Phone);
  };

  const updateTTNhanVay = (value) => {
    setTTNhanVay(value);
  };
  const updateTTNhanVayNote = (field) => (evt) => {
    setListHangTheChap({
      ...dataListHangTheChap,
      [field]: evt.target.value,
    });
    if (field === "TaiSanNote") {
      TTNhanVayValue.NoteTaiSan = evt.target.value;
    }

    // setTTNhanVay(TTNhanVayValue);
  };
  const newNhanVay = {
    customer: ChuNoValue,
    nhanVay: TTNhanVayValue,
  };

  const UpdateTypePaid = (TypePaid) => {
    //Sửa hợp đồng thì giữ nguyên kỳ đóng lãi/lãi suất đang có
    if (props.NhanVayID > 0) return;
    setTTNhanVay((prev) => ({
      ...prev,
      ...layMacDinhTheoKy(cauHinhNhanVay, Number(TypePaid)),
    }));
  };

  //Ref chặn bấm Lưu lại 2 lần liên tiếp trước khi state kịp render lại
  const isSavingRef = React.useRef(false);
  const [isSaving, setIsSaving] = useState(false);

  const onSubmit = () => {
    if (isSavingRef.current) return;
    if (TTNhanVayValue.IsNgayTraGoc === true) {
      let x = tinhNgayTraGocv3(
        NaN,
        // parseInt(dataChoVay.SoLanTra),
        NaN,
        // parseInt(dataChoVay.TongNgayVay),
        parseInt(TTNhanVayValue.CountTypePaid),
        TTNhanVayValue.NgayVay,
        parseInt(TTNhanVayValue.TypePaid),
        1,
        false,
        // undefined,
        TTNhanVayValue.NgayTra,
        cauHinhTinhLai.IsTongSoNgay,
        true,
      );
      TTNhanVayValue.NgayTra = x.NgayTraGoc;
      TTNhanVayValue.SoLanTra = x.SoLanTra;
    } else if (TTNhanVayValue.IsNgayTraGoc === false) {
      let x = tinhNgayTraGocv3(
        //  NaN,
        parseInt(TTNhanVayValue.SoLanTra),
        NaN,
        // parseInt(dataChoVay.TongNgayVay),
        parseInt(TTNhanVayValue.CountTypePaid),
        TTNhanVayValue.NgayVay,
        parseInt(TTNhanVayValue.TypePaid),
        1,
        false,
        undefined,
        // dataChoVay.NgayTra,
        cauHinhTinhLai.IsTongSoNgay,
        true,
      );
      TTNhanVayValue.NgayTra = x.NgayTraGoc;
      TTNhanVayValue.SoLanTra = x.SoLanTra;
    }
    TTNhanVayValue.ImageList = imageTaiSans.map(function (elem) {
      if (typeof elem.url !== "undefined") {
        return elem.url;
      } else {
        return elem;
      }
    });
    TTNhanVayValue.AnhTaiSan = imageTaiSans
      .map(function (elem) {
        if (typeof elem.url !== "undefined") {
          return elem.url;
        } else {
          return elem;
        }
      })
      .join(";");
    TTNhanVayValue.NoteTaiSan = dataListHangTheChap.TaiSanNote;
    TTNhanVayValue.HinhThucThanhToan = batHinhThucThanhToan
      ? parseInt(hinhThucThanhToan, 10)
      : null;
    TTNhanVayValue.FileDinhKems = fileDinhKems
      .map(function (elem) {
        if (typeof elem.url !== "undefined") {
          return elem.url;
        } else {
          return elem;
        }
      })
      .join(";");

    // const formatNhanVayValue = {
    //   ...TTNhanVayValue,
    //   AnhTaiSan: imageTaiSans.join(";"),
    //   NoteTaiSan: NoteTaiSan,
    //   FileDinhKems: fileDinhKems
    //     .map(function (elem) {
    //       if (typeof elem.url !== "undefined") {
    //         return elem.url;
    //       } else {
    //         return elem;
    //       }
    //     })
    //     .join(";"),
    // };
    const modelNhanVay = {
      customer: ChuNoValue,
      nhanVay: TTNhanVayValue,
    };
    isSavingRef.current = true;
    setIsSaving(true);
    NhanVayApi.addAndEdit({
      customer: ChuNoValue,
      nhanVay: TTNhanVayValue,
    })
      .then((response) => {
        //Mất mạng/timeout: apisauce trả data null, server có thể đã lưu nên nhắc kiểm tra trước khi lưu lại
        if (!response.data) {
          pushNotification(
            "Không nhận được phản hồi từ máy chủ, vui lòng kiểm tra lại danh sách hợp đồng trước khi lưu lại!",
            "error",
            "TOP_CENTER",
            5000,
          );
          return;
        }
        if (response.data.Error === 1) {
          pushNotification(response.data.Message, "error", "TOP_CENTER", 1000);
          return;
        } else {
          // showAlert();
          pushNotification(response.data.Message, "success", "TOP_CENTER", 1000);
          props.onHide();
          dispatch(getListNhanVay(dataSearch));
        }
      })
      .finally(() => {
        isSavingRef.current = false;
        setIsSaving(false);
      });
  };
  return (
    <Modal
      {...props}
      size={
        IsEdit.IsAllow === false
          ? "modal-dialog modal-dialog"
          : "modal-new-size modal-new-size"
      }
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header>
        {IsEdit.IsAllow === false ? (
          <h4 className="modal-title  color7-bold" id="myModalLabel16">
            <span className="btn-icon-right">
              <img src="/app-assets/images/icon-them-moi-hop-dong-v2.png" />
            </span>{" "}
            Thông báo
          </h4>
        ) : (
          <h4 className="modal-title  color7-bold" id="myModalLabel16">
            <span className="btn-icon-right">
              <img src="/app-assets/images/icon-them-moi-hop-dong-v2.png" />
            </span>{" "}
            {props.NhanVayID > 0 ? "Sửa" : "Thêm mới"} hợp đồng nhận vay
          </h4>
        )}

        <button
          type="button"
          className="close-popup-new"
          data-dismiss="modal"
          aria-label="Close"
          onClick={props.onHide}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body style={{ padding: 0 }}>
          {IsEdit.IsAllow === false ? (
            <div className="form-body">
              <div className="form-body">
                <div className="col-lg-12">
                  {IsEdit.CoThayDoiGoc ? (
                    <div>
                      Hợp đồng{" "}
                      <span class="home-new-blue">
                        {TTNhanVayValue.MaNhanVay}
                      </span>
                      &nbsp;của khách hàng{" "}
                      <span class="home-new-blue">{ChuNoValue.CustomerName}</span>{" "}
                      đã có vay thêm/trả bớt gốc. Nên bạn không thể thực hiện
                      việc sửa.&nbsp;
                      <br />
                      Muốn sửa bạn phải xóa các phiếu vay thêm/trả bớt gốc của
                      hợp đồng trước.
                    </div>
                  ) : (
                    <div>
                      Hợp đồng{" "}
                      <span class="home-new-blue">
                        {TTNhanVayValue.MaNhanVay}
                      </span>
                      &nbsp;của khách hàng{" "}
                      <span class="home-new-blue">{ChuNoValue.CustomerName}</span>{" "}
                      đã sinh ra phiếu thu. Nên bạn không thể thực hiện việc
                      sửa.&nbsp;
                      <br />
                      Muốn sửa bạn phải đi đến phiếu thu đó tại:{" "}
                      <b>Quản lý thu chi -&gt; Thu/Chi hợp đồng</b>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="form tat-toan form-horizontal form-edit thoimoihopdong">
              <div className="form-body">
                <div className="card collapse-icon accordion-icon-rotate tab-them-moi-hop-dong">
                  <ChuNo
                    chunovalue={ChuNoValue}
                    updateChuNo={updateChuNo}
                    IsEdit={IsEdit}
                    // setTTNhanVay = {setTTNhanVay}
                  />
                </div>
                <div className="card collapse-icon accordion-icon-rotate tab-them-moi-hop-dong">
                  <ThongTinNhanVay
                    ttNhanvay={TTNhanVayValue}
                    update={updateTTNhanVay}
                    currentForm={currentForm}
                    cauHinhNhanVay={cauHinhNhanVay}
                    cauHinhTinhLai={cauHinhTinhLai}
                    UpdateTypePaid={UpdateTypePaid}
                    batHinhThucThanhToan={batHinhThucThanhToan}
                    hinhThucThanhToan={hinhThucThanhToan}
                    setHinhThucThanhToan={setHinhThucThanhToan}
                  />
                </div>
                <div className="card collapse-icon accordion-icon-rotate tab-them-moi-hop-dong">
                  <div
                    id="headingCollapse19412"
                    className="card-header  mt-1"
                    data-toggle="collapse"
                    href="#collapse19412"
                    aria-expanded="false"
                    aria-controls="collapse194"
                  >
                    <a
                      className="card-title lead info collapsed"
                      href={() => false}
                    >
                      <h3>Thế chấp</h3>
                    </a>
                  </div>
                  <div
                    id="collapse19412"
                    role="tabpanel"
                    aria-labelledby="headingCollapse9412"
                    className="card-collapse collapse"
                  >
                    <div className="card-content">
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-12 col-lg-12">
                            <div className="form-group row">
                              <label
                                className="col-md-2 label-control color7-bold"
                                for="userinput1"
                              >
                                Tài sản thế chấp
                              </label>
                              <div className="col-md-10">
                                <textarea
                                  rows="1"
                                  className="form-control input-sm text-era"
                                  placeholder="Ghi chú"
                                  ref={register}
                                  onChange={updateTTNhanVayNote("TaiSanNote")}
                                  value={dataListHangTheChap.TaiSanNote}
                                ></textarea>
                              </div>
                            </div>
                            <div className="col-md-12 mt-1">
                              <div className="row">
                                <div className="col-md-12">
                                  <UploadMultiFile
                                    images={imageTaiSans}
                                    onChange={setImageTaiSans}
                                    Code={thongTinCuaHang.Code}
                                    Files={imageTaiSans}
                                  ></UploadMultiFile>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card collapse-icon accordion-icon-rotate tab-them-moi-hop-dong">
                  <div
                    id="headingCollapse191191"
                    className="card-header mt-1"
                    data-toggle="collapse"
                    href="#collapse191191"
                    aria-expanded="false"
                    aria-controls="collapse194"
                  >
                    <a
                      className="card-title lead info collapsed"
                      href={() => false}
                    >
                      <h3>Đính kèm file</h3>
                    </a>
                  </div>
                  <div
                    id="collapse191191"
                    role="tabpanel"
                    aria-labelledby="headingCollapse9412"
                    className="card-collapse collapse"
                  >
                    <div className="card-content">
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-12 col-lg-12">
                            <UploadMultiFile1
                              Files={fileDinhKems}
                              onChange={setFileDinhKems}
                              Code={thongTinCuaHang.Code}
                            ></UploadMultiFile1>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="modal-footer button-popup-new-size">
          {IsEdit.IsAllow === false ? (
            <a
              className="btn btn-new-main btn-closenew"
              onClick={props.onHide}
              href={() => false}
            >
              <span className="btn-icon-left">
                <i className="mdi mdi-close"></i>
              </span>{" "}
              Đóng
            </a>
          ) : (
            <>
              <a
                className="btn btn-new-main btn-closenew"
                onClick={props.onHide}
                href={() => false}
              >
                <span className="btn-icon-left">
                  <i className="mdi mdi-close"></i>
                </span>{" "}
                Đóng
              </a>
              <button
                className="btn btn-new-main btn-checknew"
                type="submit"
                disabled={isSaving}
              >
                {isSaving ? (
                  <>
                    <span className="spinner-border spinner-border-sm"></span>
                    &nbsp; Đang lưu...
                  </>
                ) : (
                  <>
                    <span className="btn-icon-left">
                      <i className="mdi mdi-check"></i>
                    </span>{" "}
                    Lưu lại
                  </>
                )}
              </button>
            </>
          )}
        </Modal.Footer>
      </form>
    </Modal>
  );
};
